export default __webpack_public_path__ + "static/accessories-c3f14f701b40afdeb22474fc6c6ff502.png";